import React from 'react'
import { Formik, Form, Field, FieldArray } from 'formik'
import '../Dynamic Form/DynamicStudent.css'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { TextField } from 'formik-material-ui'
import Card from 'react-bootstrap/Card';
import { Container } from 'react-bootstrap'


const initialValues = {
    students: [{
        firstname: '',
        lastname: '',
        enrollment: '',
        email: '',
        standards: [{
            standard: '',
            remarks: '',
            percentage: ''

        }]
    }]
}
const dynamicFormschema = Yup.object().shape({
    students: Yup.array().of(
        Yup.object().shape({
            firstname: Yup.string().required('❗Required').min(2).max(25),
            lastname: Yup.string().required('❗Required').min(2).max(25),
            email: Yup.string().email('❗Invalid email Format').required("❗Email is Required!"),
            enrollment: Yup.number().required("❗Enrollment Number is required").min(9),
            standards: Yup.array().of(
                Yup.object().shape({
                    standard: Yup.number().required('❗ Standard Value Required').max(12),
                    remarks: Yup.string().required('❗Remarks Required').max(2),
                    percentage: Yup.number().required('❗Percentage Required').max(100)
                })
            )
        })
    )
})
export const DynamicStudent = () => {
    const navigate = useNavigate();
    const onSubmit = (values, onSubmitProps) => {
        console.log("FormData", values);
        console.log("submitProps", onSubmitProps);
        onSubmitProps.setSubmitting(false);
        localStorage.setItem('students', JSON.stringify(values));
        navigate('/projects/4/students', { state: values });
    }

    return (
        <>
            <Container className='m-auto' >
                <Card style={{ marginTop: "15px" }}>
                  <Card.Title className='m-2'>Student Information</Card.Title>
                    <Card.Body>
                        <Container>
                            <Formik initialValues={initialValues}
                                validationSchema={dynamicFormschema}
                                onSubmit={onSubmit}
                                validateOnMount >

                                {
                                    formik => {
                                        console.log('Formik props', formik)
                                        return (
                                            <Form>
                                                <FieldArray name='students'>
                                                    {
                                                        (fieldArrayProps) => {
                                                            {/* console.log(fieldArrayProps); */ }
                                                            const { push, remove, form } = fieldArrayProps;
                                                            const { values } = form;
                                                            const { students } = values;
                                                            console.log("errors", form.errors)

                                                            return (
                                                                <>

                                                                    <Button variant="contained" color="success" onClick={() => push({
                                                                        firstname: '',
                                                                        lastname: '',
                                                                        enrollment: '',
                                                                        email: '',
                                                                        standards: [{
                                                                            standard: '',
                                                                            remarks: '',
                                                                            percentage: ''

                                                                        }]
                                                                    })}>

                                                                        <AddIcon />Add Student
                                                                    </Button>


                                                                    {
                                                                        students.map((curr, index) => {
                                                                            return (
                                                                                <>
                                                                                    <Card style={{ marginTop: "10px" }}>
                                                                                        <Card.Header>Student {index + 1}</Card.Header>
                                                                                        <Card.Body>


                                                                                            <div className="remove_button">

                                                                                                {index > 0 ? <Button variant="contained" color="primary" onClick={() => remove(index)}><RemoveCircleIcon /></Button> : null}
                                                                                            </div>

                                                                                            <div className="parentbox">
                                                                                                <div key={index}>
                                                                                                    <div class="row">
                                                                                                        <div class="col-sm">
                                                                                                            <Field type="text" name={`students[${index}].firstname`} placeholder="Firstname" component={TextField} />

                                                                                                        </div>
                                                                                                        <div class="col-sm">
                                                                                                            <Field type="text" name={`students[${index}].lastname`} placeholder="Lastname" component={TextField} />

                                                                                                        </div>
                                                                                                        <div class="col-sm">
                                                                                                            <Field type="text" name={`students[${index}].enrollment`} placeholder="Enrollment" component={TextField} />

                                                                                                        </div>
                                                                                                        <div class="col-sm">
                                                                                                            <Field type="email" name={`students[${index}].email`} placeholder="Email" component={TextField} />

                                                                                                        </div>

                                                                                                    </div>
                                                                                                    <Card className='mt-2'>
                                                                                                        {/* <Card.Header>
                                                                                                            Enter  Student {index+1}'s Grade History
                                                                                                        </Card.Header> */}
                                                                                                        <Card.Body>
                                                                                                    
                                                                                                                <FieldArray name={`students[${index}].standards`}>
                                                                                                                    {
                                                                                                                        (standardFieldArrayProps) => {
                                                                                                                            const { push, remove, form } = standardFieldArrayProps
                                                                                                                            const { values } = form
                                                                                                                            const { standards } = values.students[index]
                                                                                                                            console.log(standards)

                                                                                                                            return (
                                                                                                                                <>

                                                                                                                                    <Button variant="contained" color="success" onClick={() => push({
                                                                                                                                        standard: '',
                                                                                                                                        remarks: '',
                                                                                                                                        percentage: ''
                                                                                                                                    })}><AddIcon />  </Button>
                                                                                                                                    {
                                                                                                                                        standards.map((curStd, j) => {
                                                                                                                                            return (
                                                                                                                                                <div key={j}>
                                                                                                                                                    <div class="container m-3">
                                                                                                                                                        <div class="row">
                                                                                                                                                            <div class="col-sm">
                                                                                                                                                                <Field type="text" name={`students[${index}].standards[${j}].standard`} placeholder="Standard" component={TextField} />

                                                                                                                                                            </div>
                                                                                                                                                            <div class="col-sm">
                                                                                                                                                                <Field type="text" name={`students[${index}].standards[${j}].remarks`} placeholder="remarks" component={TextField} />

                                                                                                                                                            </div>
                                                                                                                                                            <div class="col-sm">
                                                                                                                                                                <Field type="text" name={`students[${index}].standards[${j}].percentage`} placeholder="Percentage" component={TextField} />

                                                                                                                                                            </div>

                                                                                                                                                            <div class="col-sm">
                                                                                                                                                                {j > 0 ? <Button variant="contained" color="primary" onClick={() => remove(j)}><RemoveCircleIcon /></Button> : null}
                                                                                                                                                            </div>
                                                                                                                                                        </div>
                                                                                                                                                    </div>
                                                                                                                                                </div>

                                                                                                                                            )
                                                                                                                                        })
                                                                                                                                    }
                                                                                                                                </>
                                                                                                                            )
                                                                                                                        }
                                                                                                                    }
                                                                                                                </FieldArray>
                                                                                                           

                                                                                                        </Card.Body>
                                                                                                    </Card>

                                                                                                </div>
                                                                                            </div>

                                                                                        </Card.Body>
                                                                                    </Card>


                                                                                </>
                                                                            )
                                                                        })
                                                                    }

                                                                </>
                                                            )
                                                        }
                                                    }
                                                </FieldArray>

                                                <Button variant='outlined' color='primary' type='submit' style={{ marginLeft: "90%",marginTop:"12px" }} disabled={!formik.isValid || formik.isSubmitting} >Submit</Button>

                                            </Form>
                                        )
                                    }
                                }


                            </Formik>
                        </Container>
                    </Card.Body>
                </Card>
                <div className="container m-3">

                </div>
            </Container>
        </>
    )
}


